import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "reports/loyalty-liability-report",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const liabilitySummaryReport =
            require("./LiabilitySummaryReport").default;
          cb(null, liabilitySummaryReport);
        },
        "LiabilitySummaryReport"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/LiabilitySummaryReport/index.js